import EcotaxesTab from "@features/comptabilite/components/ecotaxes/EcotaxesTab";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { TrendingUp } from "lucide-react";

export const Route = createFileRoute("/_app/comptabilite/ecotaxes/")({
  staticData: {
    title: "Éco-taxes",
    icon: TrendingUp,
    tab_icon: TrendingUp,
    permission: PERMISSIONS.COMPTABILITE.ECOTAXES.VIEW,
    module: "comptabilite",
    order: 60,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  component: EcotaxesTab,
});
